import { useMutation, useQueryClient } from "@tanstack/react-query";
import { approveSignupRequest, SignupRequestDecisionResponse } from "../../../api/signupRequestsApi";
import { SignupRequest } from "../../../pages/Admin/UserRequests/signupRequestsMockData";
import { SIGNUP_REQUESTS_QUERY_KEY } from "./useSignupRequests";

// { status: "failure" } is a real, non-throwing response shape (not an HTTP error) - checked
// explicitly rather than trusting onSuccess alone, same reasoning as
// useDecideDashboardAccessRequest.ts's own wasSuccessful check.
const wasSuccessful = (response: SignupRequestDecisionResponse) => response?.status === "success";

export const useApproveSignupRequest = () => {
  const queryClient = useQueryClient();
  return useMutation(({ id, domain }: { id: number; domain: string }) => approveSignupRequest(id, domain), {
    onSuccess: (result, { id }) => {
      if (!wasSuccessful(result)) return;
      queryClient.setQueryData<SignupRequest[]>(SIGNUP_REQUESTS_QUERY_KEY, (current) =>
        (current ?? []).filter((request) => request.id !== id)
      );
    },
  });
};
